// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-container {
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}

.dashboard-header {
  margin-bottom: 2rem;
}

.dashboard-header h1 {
  margin: 0 0 0.5rem 0;
  color: #333;
  font-size: 2.5rem;
  font-weight: 700;
}

.last-update {
  margin: 0;
  color: #666;
  font-size: 0.9rem;
}

.dashboard-top-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

@media (max-width: 1200px) {
  .dashboard-top-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .dashboard-top-row {
    grid-template-columns: 1fr;
  }
}

.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.dashboard-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.dashboard-card.main-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.dashboard-top-row .dashboard-card.main-card {
  grid-column: span 1;
}

.dashboard-card.main-card .card-header h2,
.dashboard-card.main-card .card-value,
.dashboard-card.main-card .breakdown-label,
.dashboard-card.main-card .breakdown-value {
  color: white;
}

.dashboard-card.main-card .card-link {
  color: rgba(255, 255, 255, 0.9);
}

.dashboard-card.main-card .card-link:hover {
  color: white;
}

.dashboard-card.positive {
  border-left: 4px solid #4caf50;
}

.dashboard-card.negative {
  border-left: 4px solid #d32f2f;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.card-header h2 {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
}

.card-link {
  color: #667eea;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  transition: color 0.2s ease;
}

.card-link:hover {
  color: #764ba2;
  text-decoration: underline;
}

.card-value {
  font-size: 2.5rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 1rem;
  font-family: 'Courier New', monospace;
}

.card-value.pnl-value {
  font-size: 2rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-value.main-value {
  font-size: 3rem;
  margin-bottom: 1.5rem;
}

.card-value.positive {
  color: #4caf50;
}

.card-value.negative {
  color: #d32f2f;
}

.card-breakdown {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.breakdown-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.breakdown-label {
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
}

.breakdown-value {
  font-weight: 600;
  font-size: 1.1rem;
  color: white;
  font-family: 'Courier New', monospace;
}

.breakdown-value.positive {
  color: #4caf50;
}

.breakdown-value.negative {
  color: #d32f2f;
}

.realized-pnl-breakdown {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding-top: 1rem;
  margin-top: 1rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.realized-pnl-breakdown .breakdown-label {
  color: #666;
  font-size: 0.9rem;
}

.realized-pnl-breakdown .breakdown-value {
  font-weight: 600;
  font-size: 1rem;
  font-family: 'Courier New', monospace;
}

.option-types-card {
  grid-column: span 2;
}

.option-types-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-top: 1rem;
}

.option-type-item {
  padding: 1rem;
  border-radius: 8px;
  text-align: center;
  background: #f9f9f9;
  transition: background-color 0.2s ease;
}

.option-type-item:hover {
  background: #f0f0f0;
}

.option-type-item.long-call {
  border-left: 4px solid #4caf50;
}

.option-type-item.short-call {
  border-left: 4px solid #ff9800;
}

.option-type-item.long-put {
  border-left: 4px solid #2196f3;
}

.option-type-item.short-put {
  border-left: 4px solid #f44336;
}

.option-type-label {
  font-size: 0.85rem;
  color: #666;
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.option-type-count {
  font-size: 2rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0.25rem;
}

.option-type-value {
  font-size: 0.9rem;
  color: #666;
  font-family: 'Courier New', monospace;
}

.exposure-card {
  grid-column: span 1;
  border-left: 4px solid #ff9800;
}

.exposure-value {
  color: #ff9800;
  font-size: 2rem;
}

.exposure-note {
  margin-top: 0.75rem;
  font-size: 0.85rem;
  color: #666;
  font-style: italic;
}

.stats-card {
  grid-column: span 1;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin-top: 1rem;
}

.account-breakdown-card {
  grid-column: span 2;
}

.account-breakdown-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1rem;
}

.account-breakdown-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  background: #f9f9f9;
  border-radius: 6px;
  transition: background-color 0.2s ease;
}

.account-breakdown-item:hover {
  background: #f0f0f0;
}

.account-breakdown-name {
  font-weight: 500;
  color: #333;
}

.account-breakdown-count {
  font-weight: 600;
  color: #667eea;
  font-family: 'Courier New', monospace;
}

.stat-item {
  text-align: center;
  padding: 1rem;
  background: #f9f9f9;
  border-radius: 8px;
}

.stat-label {
  font-size: 0.85rem;
  color: #666;
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.stat-value {
  font-size: 2rem;
  font-weight: 700;
  color: #667eea;
}

.dashboard-actions {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}

.refresh-btn {
  padding: 0.75rem 2rem;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.refresh-btn:hover {
  background: #5568d3;
}

/* Chart Cards */
.dashboard-card.chart-card {
  grid-column: span 1;
}

.equity-graph-full-width {
  width: 100%;
  grid-column: 1 / -1;
}

.chart-container {
  width: 100%;
  height: 250px;
  margin-top: 1rem;
}

/* Responsive charts */
@media (max-width: 768px) {
  .dashboard-card.chart-card {
    grid-column: span 1;
  }
  
  .chart-container {
    height: 200px;
  }
}

.loading, .error {
  text-align: center;
  padding: 3rem 2rem;
  font-size: 1.1rem;
}

.error {
  color: #d32f2f;
  background-color: #ffebee;
  border-radius: 4px;
  border: 1px solid #ffcdd2;
  margin-bottom: 1rem;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .dashboard-card.main-card {
    grid-column: span 1;
  }

  .option-types-card {
    grid-column: span 1;
  }

  .option-types-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .account-breakdown-card {
    grid-column: span 1;
  }
}

@media (max-width: 768px) {
  .home-container {
    padding: 1rem;
  }

  .dashboard-header h1 {
    font-size: 2rem;
  }

  .dashboard-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .dashboard-card.main-card {
    grid-column: span 1;
  }

  .option-types-card {
    grid-column: span 1;
  }

  .option-types-grid {
    grid-template-columns: 1fr;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .account-breakdown-card {
    grid-column: span 1;
  }

  .card-value {
    font-size: 2rem;
  }

  .card-value.main-value {
    font-size: 2.5rem;
  }

  .exposure-value {
    font-size: 1.75rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/Home.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".home-container {\n  padding: 2rem;\n  max-width: 1400px;\n  margin: 0 auto;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.dashboard-header {\n  margin-bottom: 2rem;\n}\n\n.dashboard-header h1 {\n  margin: 0 0 0.5rem 0;\n  color: #333;\n  font-size: 2.5rem;\n  font-weight: 700;\n}\n\n.last-update {\n  margin: 0;\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.dashboard-top-row {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n@media (max-width: 1200px) {\n  .dashboard-top-row {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .dashboard-top-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n.dashboard-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.dashboard-card {\n  background: white;\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.dashboard-card.main-card {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.dashboard-top-row .dashboard-card.main-card {\n  grid-column: span 1;\n}\n\n.dashboard-card.main-card .card-header h2,\n.dashboard-card.main-card .card-value,\n.dashboard-card.main-card .breakdown-label,\n.dashboard-card.main-card .breakdown-value {\n  color: white;\n}\n\n.dashboard-card.main-card .card-link {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.dashboard-card.main-card .card-link:hover {\n  color: white;\n}\n\n.dashboard-card.positive {\n  border-left: 4px solid #4caf50;\n}\n\n.dashboard-card.negative {\n  border-left: 4px solid #d32f2f;\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.card-header h2 {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #333;\n}\n\n.card-link {\n  color: #667eea;\n  text-decoration: none;\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: color 0.2s ease;\n}\n\n.card-link:hover {\n  color: #764ba2;\n  text-decoration: underline;\n}\n\n.card-value {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 1rem;\n  font-family: 'Courier New', monospace;\n}\n\n.card-value.pnl-value {\n  font-size: 2rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.card-value.main-value {\n  font-size: 3rem;\n  margin-bottom: 1.5rem;\n}\n\n.card-value.positive {\n  color: #4caf50;\n}\n\n.card-value.negative {\n  color: #d32f2f;\n}\n\n.card-breakdown {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding-top: 1rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.breakdown-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.breakdown-label {\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 0.9rem;\n}\n\n.breakdown-value {\n  font-weight: 600;\n  font-size: 1.1rem;\n  color: white;\n  font-family: 'Courier New', monospace;\n}\n\n.breakdown-value.positive {\n  color: #4caf50;\n}\n\n.breakdown-value.negative {\n  color: #d32f2f;\n}\n\n.realized-pnl-breakdown {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding-top: 1rem;\n  margin-top: 1rem;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.realized-pnl-breakdown .breakdown-label {\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.realized-pnl-breakdown .breakdown-value {\n  font-weight: 600;\n  font-size: 1rem;\n  font-family: 'Courier New', monospace;\n}\n\n.option-types-card {\n  grid-column: span 2;\n}\n\n.option-types-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.option-type-item {\n  padding: 1rem;\n  border-radius: 8px;\n  text-align: center;\n  background: #f9f9f9;\n  transition: background-color 0.2s ease;\n}\n\n.option-type-item:hover {\n  background: #f0f0f0;\n}\n\n.option-type-item.long-call {\n  border-left: 4px solid #4caf50;\n}\n\n.option-type-item.short-call {\n  border-left: 4px solid #ff9800;\n}\n\n.option-type-item.long-put {\n  border-left: 4px solid #2196f3;\n}\n\n.option-type-item.short-put {\n  border-left: 4px solid #f44336;\n}\n\n.option-type-label {\n  font-size: 0.85rem;\n  color: #666;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n}\n\n.option-type-count {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 0.25rem;\n}\n\n.option-type-value {\n  font-size: 0.9rem;\n  color: #666;\n  font-family: 'Courier New', monospace;\n}\n\n.exposure-card {\n  grid-column: span 1;\n  border-left: 4px solid #ff9800;\n}\n\n.exposure-value {\n  color: #ff9800;\n  font-size: 2rem;\n}\n\n.exposure-note {\n  margin-top: 0.75rem;\n  font-size: 0.85rem;\n  color: #666;\n  font-style: italic;\n}\n\n.stats-card {\n  grid-column: span 1;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.account-breakdown-card {\n  grid-column: span 2;\n}\n\n.account-breakdown-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-top: 1rem;\n}\n\n.account-breakdown-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem 1rem;\n  background: #f9f9f9;\n  border-radius: 6px;\n  transition: background-color 0.2s ease;\n}\n\n.account-breakdown-item:hover {\n  background: #f0f0f0;\n}\n\n.account-breakdown-name {\n  font-weight: 500;\n  color: #333;\n}\n\n.account-breakdown-count {\n  font-weight: 600;\n  color: #667eea;\n  font-family: 'Courier New', monospace;\n}\n\n.stat-item {\n  text-align: center;\n  padding: 1rem;\n  background: #f9f9f9;\n  border-radius: 8px;\n}\n\n.stat-label {\n  font-size: 0.85rem;\n  color: #666;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n}\n\n.stat-value {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #667eea;\n}\n\n.dashboard-actions {\n  display: flex;\n  justify-content: center;\n  margin-top: 2rem;\n}\n\n.refresh-btn {\n  padding: 0.75rem 2rem;\n  background: #667eea;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.refresh-btn:hover {\n  background: #5568d3;\n}\n\n/* Chart Cards */\n.dashboard-card.chart-card {\n  grid-column: span 1;\n}\n\n.equity-graph-full-width {\n  width: 100%;\n  grid-column: 1 / -1;\n}\n\n.chart-container {\n  width: 100%;\n  height: 250px;\n  margin-top: 1rem;\n}\n\n/* Responsive charts */\n@media (max-width: 768px) {\n  .dashboard-card.chart-card {\n    grid-column: span 1;\n  }\n  \n  .chart-container {\n    height: 200px;\n  }\n}\n\n.loading, .error {\n  text-align: center;\n  padding: 3rem 2rem;\n  font-size: 1.1rem;\n}\n\n.error {\n  color: #d32f2f;\n  background-color: #ffebee;\n  border-radius: 4px;\n  border: 1px solid #ffcdd2;\n  margin-bottom: 1rem;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .dashboard-card.main-card {\n    grid-column: span 1;\n  }\n\n  .option-types-card {\n    grid-column: span 1;\n  }\n\n  .option-types-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .account-breakdown-card {\n    grid-column: span 1;\n  }\n}\n\n@media (max-width: 768px) {\n  .home-container {\n    padding: 1rem;\n  }\n\n  .dashboard-header h1 {\n    font-size: 2rem;\n  }\n\n  .dashboard-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .dashboard-card.main-card {\n    grid-column: span 1;\n  }\n\n  .option-types-card {\n    grid-column: span 1;\n  }\n\n  .option-types-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .account-breakdown-card {\n    grid-column: span 1;\n  }\n\n  .card-value {\n    font-size: 2rem;\n  }\n\n  .card-value.main-value {\n    font-size: 2.5rem;\n  }\n\n  .exposure-value {\n    font-size: 1.75rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
